import React, { FC, useContext } from 'react';
import 'twin.macro';
import { CandidateContext, CandidateDetailTab } from 'context/CandidateContext';
import { ApplicationMetricResponse } from 'types/dashboard/types';
import { Routes } from 'types/routeTypes';
import IconCard from '../icon-card/IconCard';
import TimeStamp from '../timestamp/TimeStamp';
import useNavigationContext from 'hooks/context/nav-context';
import { SkeletonList1 } from 'components/skeleton/skeleton-list/SkeletonList';
import { GET_APPLICATION_METRICS } from 'graphql/dashboard/application-metrics/queries';
import { useQuery } from 'hooks/sympl-query';
import { useNavigate } from 'react-router-dom';

const ApplicationsList: FC = () => {
  const navigate = useNavigate();

  const { setActiveDetailTab } = useContext(CandidateContext);
  const { setActiveVacancy, activeCustomer } = useNavigationContext();

  const { loading, data } = useQuery<ApplicationMetricResponse>(
    GET_APPLICATION_METRICS,
    {
      fetchPolicy: 'no-cache',
      skip: !activeCustomer,
    }
  );

  const applications = data?.campaignMetrics?.applications ?? [];

  if (loading) return <SkeletonList1 rows={3} />;

  if (applications.length <= 0)
    return (
      <p tw="text-center text-gray-500 bg-white shadow rounded-md p-4">
        No applicants yet this week.
      </p>
    );

  const handleClick = (procedureId: number, vacancyId: number): void => {
    setActiveDetailTab(CandidateDetailTab.DETAILS);
    setActiveVacancy({ vacancyId: vacancyId });
    navigate(Routes.PROCEDURES + '/' + procedureId);
  };

  return (
    <ul tw="w-full flex flex-col justify-start space-y-2">
      {applications.slice(0, 5).map((application, index) => (
        <li key={index}>
          <IconCard
            icon="new-user"
            label={application.candidate_name}
            sublabel={application.vac_name}
            suffix={<TimeStamp time={application.inbound_date} />}
            onClick={() => handleClick(application.proc_id, application.vac_id)}
          />
        </li>
      ))}
    </ul>
  );
};

export default ApplicationsList;
